import { Box, Divider, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { LinkTab, TabType, useTabStyles } from "~/components/GenericTab";
import { useAppSelector } from "~/redux/store/store";

type Params = {
  id: string;
  tab: string;
};

export const ProjectTabs = () => {
  const { tab, id } = useParams<Params>();
  const history = useHistory();
  const classes = useTabStyles();
  const isMobile = useAppSelector((s) => s.general.isMobile);
  const { t } = useTranslation();

  const tabs: Omit<TabType, "component">[] = [
    {
      id: "details",
      label: t("projects:details"),
      href: `/projects/${id}/details`,
    },
    {
      id: "map",
      label: t("general:map"),
      href: `/projects/${id}/map`,
    },
    {
      id: "sub-areas",
      label: t("general:sub-areas"),
      href: `/projects/${id}/sub-areas`,
    },
    {
      id: "upload-progress",
      label: t("projects:uploadProgress"),
      href: `/projects/${id}/upload-progress`,
    },
    {
      id: "upload-planning",
      label: t("projects:uploadPlanning"),
      href: `/projects/${id}/upload-planning`,
    },

    {
      id: "wpr",
      label: t("projects:wpr"),
      href: `/projects/${id}/wpr`,
    },
  ];

  return (
    <Box>
      <Tabs
        TabIndicatorProps={{ className: classes.indicator }}
        indicatorColor="secondary"
        value={tab}
        variant={isMobile ? "scrollable" : undefined}
        scrollButtons="auto"
        onChange={(_, val) => history.push(`${val}`)}
        sx={{ maxWidth: "100%" }}
      >
        {tabs.map((_tab) => (
          <LinkTab
            key={_tab.id}
            value={_tab.id}
            label={_tab.label}
            href={_tab.href}
            disabled={_tab.disabled ?? false}
            sx={{
              marginLeft: 0,
              justifyContent: "flex-end",
              paddingBottom: "5px !important",
            }}
          />
        ))}
      </Tabs>
      <Divider />
    </Box>
  );
};
